import './Avatar.scss'

import classNames from 'classnames'
import AvatarPlaceholder from 'img/user-placeholder-60.png'
import { Self } from 'lib/util/self'
import React, { ImgHTMLAttributes, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface AvatarProps extends ImgHTMLAttributes<HTMLImageElement> {
  self: Self
  size?: string
}

export default function Avatar(props: AvatarProps): JSX.Element {
  const { className, self, size = 'micro', ...otherProps } = props
  const mergedClassName = classNames('avatar', className)
  const url = `${process.env.ID_MAPPER_URI}/v1/avatars/${encodeURIComponent(self.id)}?size=${encodeURIComponent(size)}`
  const [t] = useTranslation()
  const [loadingErrorHandled, setLoadingErrorHandled] = useState(false)

  return (
    <img
      alt={t('header.avatar.alt', { email: self.email })}
      className={mergedClassName}
      src={url}
      onError={e => {
        if (!loadingErrorHandled) {
          e.currentTarget.src = AvatarPlaceholder
        }
        setLoadingErrorHandled(true)
      }}
      {...otherProps}
    />
  )
}
